var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasDelete('client-agreements'))?_c('delete-icon-button',{on:{"click":function($event){return _vm.deleteContract(_vm.item)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }